module.exports = __webpack_public_path__ + "av.no2.484cfb10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/av.no2.jpg
// module id = utwF
// module chunks = 0